import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: '#F6F7F9',
    },
    headerContainer: {
        paddingTop: theme.spacing(3),
    },
    content: {
        padding: theme.spacing(2),
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    AvatarSmall: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: '#57769A !important',
    },
    AvatarText: {
        textAlign: 'left',
        fontSize: 25,
    },
    accountTab: {
        marginBottom: theme.spacing(4),
    },
    updateButton: {
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        height: '40.5px',
        width: '100%',
    },
    roleSelection: {
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
    },
    dialogContent: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
    },
}))

export default useStyles
